import { render, staticRenderFns } from "./TopicPostShare.vue?vue&type=template&id=bd6a88de&scoped=true&lang=html&"
import script from "./TopicPostShare.vue?vue&type=script&lang=js&"
export * from "./TopicPostShare.vue?vue&type=script&lang=js&"
import style0 from "./TopicPostShare.vue?vue&type=style&index=0&id=bd6a88de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a88de",
  null
  
)

export default component.exports